"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.max-safe-integer");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getDelawareRulesList;

var _lodash = _interopRequireDefault(require("lodash"));

var _Asset = _interopRequireDefault(require("../Asset"));

var _IDCounter = _interopRequireDefault(require("../../utils/IDCounter"));

var _subTypes = require("../../assets/subTypes");

var _tertiaryTypes = require("../../assets/tertiaryTypes");

var _Rule = require("../Rule");

var _commonRules = require("./commonRules");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var stateCode = 'NV';

function getDelawareRulesList(idCounter) {
  return [(0, _commonRules.taxExemptRetirementAccounts)(idCounter, stateCode), (0, _commonRules.thriftSavingsPlans)(idCounter, stateCode), {
    id: idCounter.increment(),
    description: 'Books, Works of Art, Musical instruments, Jewelry',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(a)',
    limitAggregateSingle: 5000,
    limitAggregateJoint: 10000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.ARTWORK, _subTypes.BOOK, _subTypes.MUSICAL_INSTRUMENT, _subTypes.JEWELRY];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Keepsakes and Pictures',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(a)',
    limitAggregateSingle: 5000,
    limitAggregateJoint: 10000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.FAMILY_PHOTOS];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Earned Income Credit, Tax refunds from the earned income credit',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(aa)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.TAX_CREDIT, _subTypes.TAX_REFUND];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Household Goods, Furniture, Electronics, Clothing etc., Electronics, Equipment for sports and hobbies, Clothing',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(b)',
    limitAggregateSingle: 12000,
    limitAggregateJoint: 24000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.HOUSEHOLD, _subTypes.ELECTRONICS, _subTypes.CLOTHES, _subTypes.SPORTS_OR_HOBBY_EQUIPMENT];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Stock in closely held corporations',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(bb); Nev. Rev. Stat. Ann. § 78.746',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validSubTypes = [_subTypes.STOCK];
      var validTertiaryType = [_tertiaryTypes.PRIVATE_STOCK];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType) && validTertiaryType.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Farm Equipment, Farm and fishing supplies, chemicals, and feed',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(c)',
    limitAggregateSingle: 4500,
    limitAggregateJoint: 9000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.FARMING_EQUIPMENT, _subTypes.FARMING_SUPPLIES];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Trusts',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(cc)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.TRUST];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Tools of Trade',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(d)',
    limitAggregateSingle: 10000,
    limitAggregateJoint: 20000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.TOOLS_OF_TRADE];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Spendthrift trust',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(dd)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTertiaryType = [_tertiaryTypes.SPENDTHRIFT_TRUST];
      return this.canTakeMoreExemptions() && validTertiaryType.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Mining assets',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(e)',
    limitAggregateSingle: 4500,
    limitAggregateJoint: 9000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTertiaryType = [_tertiaryTypes.MINING_ASSETS];
      return this.canTakeMoreExemptions() && validTertiaryType.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Disability Proceeds',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(ee)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.PROCEEDS_FROM_HEALTH_OR_DIABILITY_INSURANCE_CLAIM];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Motor Vehicle (unlimited if disabled)',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(f); Nev. Rev. Stat. Ann. § 21.090 (1)(p)',
    limitAggregateSingle: 15000,
    limitAggregateJoint: 30000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: 1,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.AUTOMOBILE];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    },
    transformFromContext: function transformFromContext() {// Disabled person
    }
  }, {
    id: idCounter.increment(),
    description: 'Wages - 82% or 50 times the federal min hourly wage or less than $770',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(g)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.WAGES];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: "Workers' compensation",
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(gg)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WORKERS_COMP;
    }
  }, {
    id: idCounter.increment(),
    description: 'Unemployment Compensation',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(hh); Nev. Rev. Stat. Ann. § 612.710',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.UNEMPLOYMENT_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Arms, uniforms, one gun, required by law',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(i)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: 1,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.FIREARMS, _subTypes.UNIFORMS_REQUIRED_BY_LAW];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Vocational rehabilitation',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(jj); Nev. Rev. Stat. Ann. § 615.270',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.VOCATIONAL_REHABILITATION_BENEFITS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance Proceeds',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(k)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.LIFE_INSURANCE_PROCEEDS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Blind Aged Disabled, Public assistance',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(kk); Nev. Rev. Stat. Ann. § 422.291; Nev. Rev. Stat. Ann. § 422A.325',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.AID_TO_BLIND;
    }
  }, {
    id: idCounter.increment(),
    description: 'Public assistance for children',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(ll); Nev. Rev. Stat. Ann. § 432.036',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.PUBLIC_CHILD_ASSISTANCE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Health Aids (prescribed by doctor or dentist)',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(q)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.HEALTHAID;
    }
  }, {
    id: idCounter.increment(),
    description: 'ERISA, IRAs, SEP IRA, Roth IRA, higher edu. savings plans',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(r)',
    limitAggregateSingle: 500000,
    limitAggregateJoint: 1000000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTertiaryTypes = [_tertiaryTypes.ERISA_REITREMENT_PLAN, _subTypes.IRA, _subTypes.COLLEGE_SAVINGS_ACCOUNT];
      return this.canTakeMoreExemptions() && validTertiaryTypes.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Alimony and child support',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(t),(s)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.ALIMONY, _subTypes.CHILD_SUPPORT];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Personal injury',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(u)',
    limitAggregateSingle: 16150,
    limitAggregateJoint: 32300,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.PERSONAL_INJURY_COMPENSATION];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Wrongful death awards',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(v)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.WRONGFUL_DEATH_AWARD];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Loss of future earnings',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(w)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.LOSS_OF_FUTURE_EARNINGS_COMPENSATION];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: "Crime victim's compensation",
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(x)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.CRIME_VICTIM_COMPENSATION];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Restitution received for criminal act',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(x)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.CRIME_VICTIM_COMPENSATION];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Social Security',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (1)(y)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTertiaryTypes = [_tertiaryTypes.SOCIAL_SECURITY];
      return this.canTakeMoreExemptions() && validTertiaryTypes.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Rental Deposits',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090(1)(n)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTertiaryTypes = [_tertiaryTypes.SECURITY_DEPOSIT];
      return this.canTakeMoreExemptions() && validTertiaryTypes.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Geology and Paleontology Collections',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.100',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTertiaryTypes = [_tertiaryTypes.GEOLOGY_PALEONTOLOGY_COLLECTIONS];
      return this.canTakeMoreExemptions() && validTertiaryTypes.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Public Employees Pensions',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 286.670; Nev. Rev. Stat. Ann. § 21.090 (1)(ii)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTypes = [_tertiaryTypes.DISTRICT_EMPLOYEES_PENSION, _tertiaryTypes.PUBLIC_EMPLOYEE_PENSION, _tertiaryTypes.STATE_EMPLOYEES_PENSION];
      return this.canTakeMoreExemptions() && validTypes.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: "Industrial Worker's Insurance Compensation",
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 616C.205',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTypes = [_tertiaryTypes.INDUSTRIAL_WORKERS_COMP_INSURANCE];
      return this.canTakeMoreExemptions() && validTypes.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Escrow Funds',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 645A.170',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.ESCROW];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Mortgage impound accounts',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 645B.180',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTertiaryTypes = [_tertiaryTypes.MORTGAGE_IMPOUND_ACCOUNT];
      return this.canTakeMoreExemptions() && validTertiaryTypes.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Uninsured Life proceeds',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 687B.260',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTertiaryTypes = [_tertiaryTypes.LIFE_INSURANCE_PROCEEDS];
      return this.canTakeMoreExemptions() && validTertiaryTypes.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Health Proceeds',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 687B.270',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTertiaryTypes = [_tertiaryTypes.LIFE_INSURANCE_PROCEEDS];
      return this.canTakeMoreExemptions() && validTertiaryTypes.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Group Life Policy or Proceeds',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 687B.280',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTertiaryTypes = [_tertiaryTypes.GROUP_INSURANCE_PLAN, _tertiaryTypes.GROUP_INSURANCE_PROCEEDS];
      return this.canTakeMoreExemptions() && validTertiaryTypes.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Annuity Proceeds',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 687B.290',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.ANNUITY];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Funeral or burial service trust money',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 689.700; Nev. Rev. Stat. Ann. § 21.090 (1)(ff)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTertiaryTypes = [_tertiaryTypes.FUNERAL_TRUST];
      return this.canTakeMoreExemptions() && validTertiaryTypes.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Fraternal Benefits',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 695A.220',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.FRATERNAL_BENEFIT];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Partnership Property',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 87.250',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.PARTNERSHIP_PROPERTY];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: _Rule.WILDCARD_ID,
    description: 'Wildcard',
    type: stateCode,
    statuteName: 'Nev. Rev. Stat. Ann. § 21.090 (z)',
    limitAggregateSingle: 10000,
    limitAggregateJoint: 20000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply() {
      return this.canTakeMoreExemptions();
    }
  }];
}